class PackageModal {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.modalParent = element.closest('.modal');
    this.init();
  }

  init() {

  }
}

export default PackageModal;
